import sittingMan from './sittingMan';
import sittingPaulOffice from './sittingPaulOffice';
import officeDoor from './officeDoor';

export default {
  sittingMan,
  sittingPaulOffice,
  officeDoor,
}
